const endpoints = {
  //auth
  login: "/user/login",
  changePassword: "/user/change/password",
  rolePermission: "/permission",

  //branch
  createBranch: "/branch/create",
  showSingleBranch: "/branch/show",
  allBranch: "/branch",
  updateBranchStatus: "/branch/update-status",
  updateBranch: "branch/update",

  //user
  createUser: "/user/create",
  showSingleUser: "/user/show",
  allUser: "/user",
  updateUserStatus: "/user/update-status",
  updateUser: "user/update",
  specificUsers:"user/specific-users",
  availableDoctors:"/appointment/available/doctors",

  //role
  allRole: "/master/roles",
  userRolewise: "/master/user-role-specific",

  //department
  allDepartment : "/master/departments",

  //procedure-master
  createProcedureMaster: "/procedure/create",
  allProcedureMaster: "/procedure",
  updateProcedureMaster: "procedure/update",
  updateProcedureStatusMaster: "/procedure/update-status",

  //setting
  createSetting: "/setting/create",
  allSetting: "/setting",
  getSingleSetting: "/setting",
  updateSetting: "setting/update",

  //appointment
  createAppointment: "/appointment/create",
  allAppointment: "/appointment/date/specific",
  updateAppointment: "appointment/update",
  showSingleAppointment: "/appointment/show",
  generateCaseId: "appointment/generate-caseid",
  getSingleAppointment:"appointment/show",
  

  //consultation
  createConsultation: "/consultation/create",
  updateConsultation: "/consultation/update",
  showSingleConsultation: "/consultation/show",
  pastConsultation: "/consultation/past",
  loadPreviousData: "consultation/load-previous/data",
  getSpecificPaymentHistory: "/appointment/payment/view",
  pastSession:"appointment/past/session",
  getPatentData: "invoice/generate/details",

  //procedure-package
  createPackage: "appointment/package/create",
  getProcedurePackage: "appointment/package/specific",
  updatePackage: "appointment/package/update",
  updatePackageStatus: "appointment/package/update-status/{uuid}",
  updatePackageDetailsStatus: "appointment/package/detail/update-status/{uuid}",
  allProcedureDetails: "appointment/package/procedure",
  specificPackageRegardingDetails: "appointment/package/specific/{uuid}",
  getAllPackages: "appointment/package",

  //specific-procedure
  createProcedure: "appointment/procedure/create",
  getProcedures: "appointment/procedure/{case_id}",
  updateProcedure: "appointment/procedure/update",
  showSingleProcedure: "appointment/procedure/session/show",//this for edit
  // showSingleProcedure: "appointment/show/procedure",//this for edit

  //payment
  createPayment: "appointment/consultation/payment/create",
  createProcedurePayment:"appointment/procedure/payment/create",
  createInvoice: "invoice/generate",
  createPaymentReceipt: "invoice/generate/payment/receipt",
  getPayment: "appointment/procedure/payment/view",
  paymentHistory: "appointment/procedure/payment/history",
  getMainPaymentHistory:"appointment/payment/history",
  paymentStatus: "master/payment-status",
  status: "master/status",
  getAllInvoice: "/invoice",
  getAllTransactions: "/user/all/transaction",

  //session
  editSessionViaReception: "appointment/procedure/session/update",
  editSessionViaDoctor: "appointment/procedure/session/update",
  specificViewSession:
    "appointment/procedure/session/specific/show",
  showSingleSession: "appointment/procedure/session/specific/show",

  ///media
  createCustomerDocument: "customer/document/create",
  updateCustomerDocument: "customer/document/update/{uuid}",
  getDocuments: "customer/document",
  getSingleDocument:"customer/document/show",
  getConsultationDocuments: "customer/document/consultation",
  getSessionDocuments: "customer/document/session",
  deleteDocument: "customer/document/delete",

  //upcoming-appointment
  upcomingFirstProcedure: "/appointment/upcoming/first/data",
  upcomingProcedure: "/appointment/upcoming/procedure/data",
  upcomingConsultation: "/appointment/upcoming/consultation/data",

  //patient
  getPatient: "/appointment/patient/detail",
  getAllPatient: "/patients",
  getSinglePatient: "/patients/details",
  updatePatient: "appointment/patient/detail/update",
  searchPatient: "appointment/search/patient",
  getReferenceDoctor: "appointment/reference/doctors",
  getPatientProcedureSession: "appointment/patient/procedure/session",

  //calendar
  availableSlots: "/appointment/available/slot",
  availableCalendarSlots: "/appointment/available/calendar/slot",

  todayConsultation: "appointment/calendar/consultation",
  weekConsultation: "appointment/calendar/consultation",
  monthConsultation: "appointment/calendar/consultation",

  todayProcedure: "appointment/calendar/procedure",
  weekProcedure: "appointment/calendar/procedure",
  monthProcedure: "appointment/calendar/procedure",

  todayAppointment: "appointment/calendar/all/appointments",
  weekAppointment: "appointment/calendar/all/appointments",
  monthAppointment: "appointment/calendar/all/appointments",

  //options
  countryCodeOptions:"/master/retrieve-region-data",
  countryOptions:"/master/retrieve-region-data",
  stateOptions:"/master/retrieve-region-data",
  cityOptions:"/master/retrieve-region-data",

  complaintOptions:"/master/complaint",
  severitiesOptions:"/master/severities",
  frequenciesOptions:"/master/frequencies",
  medicinesOptions:"/master/medicine",
  doseOptions:"/master/dose",
  testOptions:"/master/test",
  diagnosisOptions:"/master/diagnosis",
};

export default endpoints;
